module.exports = __webpack_public_path__ + "img/logo.3ff0eec8.png";